import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DeviceInformationComponent } from './device-information/device-information.component';

@NgModule({
  imports: [CommonModule],
  exports: [DeviceInformationComponent],
  declarations: [DeviceInformationComponent],
  providers: [],
})
export class DeviceInformationModule {}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/device-information/device-information.module.ts